import React, { Component } from 'react';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import { injectIntl } from 'react-intl';
import { reduxForm } from 'redux-form';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames'

import CurrencyConverter from '../../../CurrencyConverter/CurrencyConverter';

import messages from '../../../../locale/messages';
import getFailedTransaction from './getFailedTransaction.graphql';
import { isValidJSON } from '../../../../helpers/isValidJSON';
import s from '../../FailedPayoutOrRefundModal/FailedPayoutOrRefundModal.css';

class FailedPayoutOrRefundForm extends Component {

    render() {
        const { data: { getFailedTransaction }, type } = this.props;
        const { formatMessage } = this.props.intl;
        let payoutAmount, checkJSON, refundAmount, reason, amount, payoutFailedReason, refundFailedReason, firstNameLabel, firstName, amountLabel;

        if (getFailedTransaction?.reservationState == 'cancelled') {
            payoutAmount = getFailedTransaction?.cancellationDetails?.payoutToHost;
            refundAmount = getFailedTransaction?.cancellationDetails?.refundToGuest;
        } else {
            payoutAmount = getFailedTransaction?.total - getFailedTransaction?.hostServiceFee;
            refundAmount = getFailedTransaction?.transaction?.total;
        }

        payoutFailedReason = getFailedTransaction?.hostFailedTransaction?.reason;
        refundFailedReason = getFailedTransaction?.guestFailedTransaction?.reason;
        reason = type === 'payout' ? payoutFailedReason : refundFailedReason;

        checkJSON = isValidJSON(reason);
        reason = checkJSON ? JSON.parse(reason) : reason;
        amount = type === 'payout' ? payoutAmount : refundAmount;
        firstNameLabel = type === 'payout' ? formatMessage(messages.hostNameLabel) : formatMessage(messages.guestName);
        firstName = type === 'payout' ? getFailedTransaction?.hostData?.firstName : getFailedTransaction?.guestData?.firstName;
        amountLabel = type === 'payout' ? formatMessage(messages.payoutLabel) : formatMessage(messages.refundAmount);

        return (
            <>
                {getFailedTransaction && (
                    <div>
                        <div className={s.modalGrid}>
                            <label className={s.labelTextNew} >{formatMessage(messages.reservationId)}</label>
                            <div>{getFailedTransaction?.id}</div>
                        </div>

                        <div className={s.modalGrid}>
                            <label className={s.labelTextNew} > {formatMessage(messages.codeLabel)}</label>
                            <div>{getFailedTransaction?.confirmationCode}</div>
                        </div>

                        {getFailedTransaction.listData ? (
                            <div className={cx(s.modalGrid,'adminstyle')}>
                                <label className={s.labelTextNew} >{formatMessage(messages.adminListTitle)}</label>
                                <a href={`/rooms/${getFailedTransaction.listData.id}`} target="_blank">
                                    {getFailedTransaction?.listData?.title}
                                </a>
                            </div>
                        ) : (
                            <div className={s.modalGrid}>
                                <label className={s.labelTextNew} >{formatMessage(messages.adminListTitle)}</label>
                                <div>{formatMessage(messages.dataMissing)}</div>
                            </div>
                        )}
                        <div className={s.modalGrid}>
                            <label className={s.labelTextNew} >{firstNameLabel}</label>
                            <div>{firstName}</div>
                        </div>

                        <div className={s.modalGrid}>
                            <label className={s.labelTextNew} >{amountLabel}</label>
                            <CurrencyConverter amount={amount} from={getFailedTransaction?.currency} />
                        </div>
                        <div className={s.modalGrid}>
                            <label className={s.labelTextNew} >{formatMessage(messages.reason)}</label>
                            <div>{reason?.raw?.message ? reason?.raw?.message : reason}</div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

FailedPayoutOrRefundForm = reduxForm({
    form: 'FailedPayoutOrRefundForm', // a unique name for this form
    destroyOnUnmount: false
})(FailedPayoutOrRefundForm);

const mapState = state => ({
});

const mapDispatch = {};

export default compose(
    injectIntl,
    withStyles(s),
    connect(mapState, mapDispatch),
    graphql(getFailedTransaction,
        {
            options: (props) => ({
                variables: {
                    id: props.id
                },
                fetchPolicy: 'network-only',
                ssr: true
            })
        }
    )
)(FailedPayoutOrRefundForm);
